import React from "react";
import { Routes, Route } from "react-router-dom";
import UDISEPage from "../UDISEPage";

const UdiseRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<UDISEPage />} />
  </Routes>
);

export default UdiseRoutes;
